import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { IGroup, ILoadedWarrantyCard, IWarrantyCard, IZone } from './interfaces';

export const getWarrantyCardList = (data: IDynamicTableParams): Promise<ILoadedWarrantyCard[]> => {
  return instance()
    .post('/bigAppWarrantyCard/list', data)
    .then((response) => response.data);
};

export const getWarrantyCardAvailableColumns = (): Promise<IAvailableColumnModel[]> => {
  return instance()
    .post('/bigAppWarrantyCard/availableColumns')
    .then((response) => response.data);
};

export const getWarrantyCardAvailableGroupColumns = (): Promise<IAvailableGroupColumnModel[]> => {
  return instance()
    .post('/bigAppWarrantyCard/availableGroupColumns', {})
    .then((response) => response.data);
};

export const createWarrantyCard = (warrantyCard: IWarrantyCard): Promise<IWarrantyCard> => {
  return instance()
    .post('/bigAppWarrantyCard/create', warrantyCard)
    .then((response) => response.data);
};

export const updateWarrantyCard = (warrantyCard: IWarrantyCard): Promise<IWarrantyCard> => {
  return instance()
    .post('/bigAppWarrantyCard/update', warrantyCard)
    .then((response) => response.data);
};

export const archiveWarrantyCard = (workTypeId: number) => {
  return instance()
    .post('/bigAppWarrantyCard/archive', { workTypeId })
    .then((response) => response.data);
};

export const loadWarrantyCard = (workTypeId: number) => {
  return instance()
    .post<ILoadedWarrantyCard>('/bigAppWarrantyCard/load', { workTypeId })
    .then((response) => response.data);
};

export const recoverWarrantyCard = (workTypeId: number) => {
  return instance()
    .post('/bigAppWarrantyCard/recover', { workTypeId })
    .then((response) => response.data);
};

export const getWarrantyCardCount = () => {
  return instance()
    .post('/bigAppWarrantyCard/listCount')
    .then((response) => response.data);
};

export const getWarrantyCardGroups = (): Promise<IGroup[]> => {
  return instance()
    .post('/bigAppWarrantyCard/listGroups')
    .then((response) => response.data);
};

export const getWarrantyCardZones = (): Promise<IZone[]> => {
  return instance()
    .post('/bigAppWarrantyCard/listZones')
    .then((response) => response.data);
};

export const sendWarrantyCardToBigApp = () => {
  return instance()
    .post('/bigAppWarrantyCard/sendToBigApp')
    .then((response) => response.data);
};
